import {CashbackRequestModel} from "../../../../models/dashboard/marketplace/marketplaceCashbackRequestModel";
import {adminHttpClient} from "../../../../commons/adminHttpClinet";

const getMarketplaceCashbackRequest = (): Promise<Array<CashbackRequestModel>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplacePurchase/get-cashback-requests`)
}
export default getMarketplaceCashbackRequest;
